var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header w-100 mt-5 mb-4 d-flex justify-space-between align-center",style:('background-color: ' + _vm.backgroundColor + '; border-radius: 20px; padding: 4px 16px')},[_c('h2',{class:_vm.titleClass},[_vm._t("default")],2),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }